// Resuelve el path home del usuario logueado consultando las tablas
// `kines` y `pacientes`. Usado en bootstrap del AuthProvider para
// cachear el userRole + en pantallas que necesitan redirect post-auth.
//
// `kines.id` ES `auth.users.id` (FK directa), `pacientes.auth_user_id`
// apunta a la sesión (col separada porque pacientes.id es UUID propio).
// IDs disjuntos por construcción — un user no puede ser ambos roles.
//
// Devuelve null si no se encuentra en ninguna tabla (huérfano: auth.users
// existe pero el linkeo de dominio nunca completó, ej. signup interrumpido
// pre-AuthCallback).

import { supabase } from "@/lib/supabase/client";

export type UserRole = "kine" | "paciente";

export interface ResolvedRole {
  role: UserRole;
  homePath: string;
}

export async function resolveUserRole(
  userId: string,
): Promise<ResolvedRole | null> {
  const { data: kine } = await supabase
    .from("kines")
    .select("id")
    .eq("id", userId)
    .maybeSingle();
  if (kine) return { role: "kine", homePath: "/" };

  const { data: paciente } = await supabase
    .from("pacientes")
    .select("id")
    .eq("auth_user_id", userId)
    .maybeSingle();
  if (paciente) return { role: "paciente", homePath: "/paciente-home" };

  return null;
}
